module.exports = __webpack_public_path__ + "static/media/bmi_ftu.17a1aedb.svg";